enum StreamStartTarget {
  OBS = "start_obs",
  OBS_BROADCAST = "start_obs_broadcast",
  PRIVATE = "start_private",
  PUBLIC = "start_public",
}

export { StreamStartTarget };
